import { fabric } from 'fabric-with-gestures';
import { Canvas, Rect } from 'fabric/fabric-impl';

import CarouselSelectedImageCategory from '../../components/CarouselSelectedImageCategory/CarouselSelectedImageCategory';
import { KEY_TEXT_TOOL_OPTION } from '../../constants';
import TextFormatControls from '../../components/TextFormatControls/TextFormatControls';
import ShowIf from '../../components/UI/ShowIf';
import { CanvasHandler } from '../../handlers/CanvasHandler';

interface Resources {
  style: any;
  images: string[];
}

interface SelectedToolOptionsConfig {
  gallery: Record<string, Resources>;
  selectedTool: string;
  canvas: Canvas;
}

function SelectedToolOptions(props: SelectedToolOptionsConfig) {
  const { canvas } = props;
  const selectedGallery = props.gallery[props.selectedTool];
  const isActiveCarousel = props.selectedTool !== KEY_TEXT_TOOL_OPTION;
  const canvasHandler = new CanvasHandler(canvas);

  const handleOnSelectImage = (srcImage: string) => {
    canvasHandler.addImageElem(srcImage);
  };

  return (
    <div className="w-full bg-primary z-10 relative" style={{ height: `18%` }}>
      <ShowIf condition={isActiveCarousel} elseChildren={<TextFormatControls />}>
        <CarouselSelectedImageCategory
          onSelectImage={handleOnSelectImage}
          selectedGallery={selectedGallery}
        />
      </ShowIf>
    </div>
  );
}

export default SelectedToolOptions;
